import { render, staticRenderFns } from "./story-card.vue?vue&type=template&id=668bae28&scoped=true&"
import script from "./story-card.vue?vue&type=script&lang=js&"
export * from "./story-card.vue?vue&type=script&lang=js&"
import style0 from "./story-card.vue?vue&type=style&index=0&id=668bae28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668bae28",
  null
  
)

export default component.exports